module.exports = __webpack_public_path__ + "f5ce0212ef7f1fd858c26f6d2401bcec.pdf";